var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid grid-cols-4 gap-2"},_vm._l((_vm.years),function(year){return _c('button',{key:year,staticClass:"rounded py-1 px-3 font-semibold",class:_vm.selectedYear === year
        ? 'bg-ontick-blue-600'
        : 'bg-ontick-steel-500 filter transition-all hover:brightness-125',on:{"click":function($event){return _vm.selectYear(year)}}},[_vm._v(" "+_vm._s(year)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }